/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";



// 修改额度
export function editLine(data) {
    return axios({
        url: "/mbLine/editLine",
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        params: data
    });
}



